import { Box, Button, Typography, useTheme } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import api from '../../../service/api'
import { formatDate } from '../../../utils/utilities'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import DataLoadingSpinner from '../../common/DataLoadingSpinner'
import TryAgainMessageBlock from '../../common/TryAgainMessageBlock'
import AuditQuestionBankViewer from './AuditQuestionBankViewer'
import CustomTable from '../../common/custom-table/CustomTable'

const columns = [
    { id: 2, field: "name", name: "Questions Bank", width: "120px", padding: "10px 20px" },
    { id: 3, field: "faculty_name", linkGetter: row => `/${window.location.pathname?.includes( 'admin' ) ? "admin" : "audit"}/faculty/${row.created_by}?legacy=${row.legacy_system_data}`, renderCell: row => row.faculty_name?.toLowerCase(), cellStyles: { textTransform: "capitalize" }, name: 'Faculty name', width: "150px", align: "left", padding: "10px 20px" },
    { id: 6, field: "department", renderCell: row => row?.creator_data?.department_name?.toLowerCase(), cellStyles: { textTransform: "capitalize" }, name: 'Department', padding: "10px 20px" },
    { id: 4, field: "subject", renderCell: row => row.subject?.subject_name || "Not available", name: "Subject", padding: "10px 20px" },
    { id: 5, field: "created_at", renderCell: row => formatDate( row.created_at ), align: "center", name: "Created on", width: "200px", padding: "10px 20px" },
    { id: 7, field: "questions", align: "center", name: "questions", padding: "10px 20px" },
]


const AuditQuestionBanksList = () => {


    const [searchParams] = useSearchParams( { searchText: "", month: "", selectedDepartment: "all", selectedInstitute: "all", view: "tabular", sortByName: "1", sortBySubmissionsCount: "1", sortByAssignmentCount: "1" } )
    const selectedInstitute = searchParams.get( 'selectedInstitute' ) || "all"

    const [error, setError] = useState( null )
    const [questionBanks, setQuestionBanks] = useState( [] )
    const [loading, setLoading] = useState( true )
    const [selectedQuestionBank, setSelectedQuestionBank] = useState( null )

    const { layout } = useTheme()

    const navigate = useNavigate()
    const { pathname } = useLocation()


    const handleDialogClose = () => {
        setSelectedQuestionBank( null )
    }


    const getData = useCallback( async () => {
        try {
            setLoading( true )
            const { data: { data } } = await api.audit.getQuestionBanksForAuditing( { institute: selectedInstitute !== "all" ? selectedInstitute : "" } )
            setQuestionBanks( data )
        } catch ( err ) {
            console.log( err )
            setError( err?.message?.data?.message || "Something went wrong while fetching questionBanks." )
        } finally {
            setLoading( false )
        }
    }, [selectedInstitute] )

    useEffect( () => {
        getData()
    }, [getData] )


    return (
        <Box gap={layout.cardsGap} flexGrow={1} display="flex" flexDirection="column">

            {selectedQuestionBank && <AuditQuestionBankViewer questionbank={selectedQuestionBank} handleClose={handleDialogClose} openState={Boolean( selectedQuestionBank )} />}

            {/* Heading */}
            <Box display="flex" gap="20px" alignItems="flex-end" justifyContent="space-between" >
                <Typography variant="h1" fontWeight="600" component="h2" fontSize="14px">Question banks</Typography>
                <Button size="small" onClick={() => navigate( `/${pathname.includes( "admin" ) ? "admin" : "audit"}/questionBanks` )} variant="outlined" disableElevation color='secondary' >View Stats</Button>
            </Box >

            {/* Data */}
            {!loading && questionBanks.length > 0 && <CustomTable globalSearch="Search by study material, faculty, ID or subject" onRowClick={setSelectedQuestionBank} containerStyles={{ maxHeight: "450px" }} data={questionBanks} columns={columns} pageSize={50} />}

            {/* Retry */}
            {error && <TryAgainMessageBlock getData={getData} err={error} loading={loading} />}

            {/* Loading */}
            {loading && <DataLoadingSpinner padding="0" waitingMessage="Loading questionBanks please wait...." />}
        </Box>
    )
}

export default AuditQuestionBanksList
